import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Wallet, Loader2, ShieldCheck } from "lucide-react";
import { discoverWallets } from "@/lib/wallet";

// Lets the user pick one of the injected browser wallets, then hands its provider back.
export function WalletPicker({ open, onOpenChange, onPick, busy, title = "Connect a wallet" }) {
  const [wallets, setWallets] = useState(null);

  useEffect(() => {
    if (open) { setWallets(null); discoverWallets().then(setWallets); }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="wallet-picker" className="bg-[#0b0b0b] border-white/10 max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription className="text-zinc-400 text-xs flex gap-2 items-start">
            <ShieldCheck className="w-4 h-4 text-[#ccff00] shrink-0" />
            You'll sign a message to prove you own the wallet. No transaction, no gas, and we never ask for your seed phrase.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 mt-2">
          {wallets === null && <p className="text-sm text-zinc-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Looking for wallets…</p>}
          {wallets?.length === 0 && (
            <p data-testid="wallet-none-found" className="text-sm text-zinc-400">
              No browser wallet found. Install MetaMask, Rabby or another EVM wallet extension, then reload this page.
            </p>
          )}
          {wallets?.map((w) => (
            <button key={w.info.uuid} type="button" disabled={busy} data-testid={`wallet-option-${w.info.uuid}`}
              onClick={() => onPick(w.provider)}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl border border-white/10 hover:border-[#ccff00]/50 hover:bg-white/[0.03] transition-colors disabled:opacity-50">
              {w.info.icon ? <img src={w.info.icon} alt="" className="w-6 h-6 rounded" /> : <Wallet className="w-5 h-5 text-[#ccff00]" />}
              <span className="text-sm font-semibold">{w.info.name}</span>
              {busy && <Loader2 className="w-4 h-4 animate-spin ml-auto" />}
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
